export const DESKTOP_CONTRACT_STEP = {
    FORMVIEW: "FORMVIEW",
    DOCUMENT: "DOCUMENT"
};
export const HUDDLE_STATUS = {
    FAILED: "FAILED",
    SUBMITTED: "SUBMITTED",
    PENDING: "PENDING",
    PURCHASED: "PURCHASED",
    INITIATED: "INITIATED"
};
